export const ownPropsSelector = (state, ownProps) => ownProps;
